
export const GET_FORM = 'GET_FORM';
export const GET_FORM_SUCCESS = 'GET_FORM_SUCCESS';
export const SHOW_FORM_LOADING = 'SHOW_FORM_LOADING';
export const GET_FORM_ERROR = 'GET_FORM_ERROR';
export const FIELD_CHANGED = 'FIELD_CHANGED';
export const GET_FORM_ROW = 'GET_FORM_ROW';
